import { render, staticRenderFns } from "./DiscoveryForm.vue?vue&type=template&id=0c72427a&scoped=true&"
import script from "./DiscoveryForm.vue?vue&type=script&lang=js&"
export * from "./DiscoveryForm.vue?vue&type=script&lang=js&"
import style0 from "./DiscoveryForm.vue?vue&type=style&index=0&id=0c72427a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c72427a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c72427a')) {
      api.createRecord('0c72427a', component.options)
    } else {
      api.reload('0c72427a', component.options)
    }
    module.hot.accept("./DiscoveryForm.vue?vue&type=template&id=0c72427a&scoped=true&", function () {
      api.rerender('0c72427a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/forms/DiscoveryForm.vue"
export default component.exports